import { onLivewireCommitLifecycle } from '../../utilities/livewire-hooks';

const spinnerExceptions = [
    'disable-spinner',
    'all-filters',
    'loan-right-now',
    'filter-button',
    'loan-filter',
    'loan-verify-modal',
    'loan-verify-page-form',
    'account-order-offers',
    'cookie-consent-banner',
];

const shouldSkipSpinner = (component) => {
    const root = component?.el;

    if (!root) {
        return true;
    }

    if (root.closest('#account-order-offers')) {
        return true;
    }

    return spinnerExceptions.includes(root.id);
};

const setSpinnerDisplay = (visible) => {
    const spinner = document.getElementById('spinnerLoad');

    if (!spinner) {
        return;
    }

    spinner.style.display = visible ? 'flex' : 'none';
};

onLivewireCommitLifecycle({
    start: ({ component }) => {
        if (shouldSkipSpinner(component)) {
            return;
        }

        setSpinnerDisplay(true);
    },
    finish: ({ component }) => {
        if (shouldSkipSpinner(component)) {
            return;
        }

        setSpinnerDisplay(false);
    },
});

window.addEventListener('spinnerLoadEnd', () => {
    setSpinnerDisplay(false);
});
